export class AdditionalInfoVOForReassign{
    public rateMappingStatus:any;
    public ratePlanText:string;
    public statusGDS:any;
    public transactionCount:number;
    public workItemId:number;
}